export default __webpack_public_path__ + "static/media/truck-transport-svgrepo-com.8f5ed1a6.svg";